<div if.bind="imageCacheAdmin.panelOpen" class="modal-overlay" click.trigger="imageCacheAdmin.closePanel()">
  <div class="image-cache-admin" click.trigger="$event.stopPropagation()">
    <div class="image-cache-admin__header">
      <h3 class="image-cache-admin__title">Image cache</h3>
      <button type="button" class="image-cache-admin__close" click.trigger="imageCacheAdmin.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="image-cache-admin__body">
      <p class="image-cache-admin__hint">
        Manage the image &rarr; (brand, toy line) cache. Add or update a record to hand-tag an image when the Brand Vision service is off; leave the brand empty to mark an image as &ldquo;unidentified&rdquo;. Records are keyed by image URL.
      </p>

      <form class="image-cache-admin__form" submit.trigger="imageCacheAdmin.save()">
        <label class="image-cache-admin__field image-cache-admin__field--wide">
          <span class="image-cache-admin__label">Image URL</span>
          <input type="text" class="image-cache-admin__input" value.bind="imageCacheAdmin.formImageUrl" placeholder="https://&hellip;" disabled.bind="imageCacheAdmin.saving" />
        </label>
        <div class="image-cache-admin__field-row">
          <label class="image-cache-admin__field">
            <span class="image-cache-admin__label">Brand</span>
            <input type="text" class="image-cache-admin__input" value.bind="imageCacheAdmin.formBrand" placeholder="(empty = unidentified)" disabled.bind="imageCacheAdmin.saving" />
          </label>
          <label class="image-cache-admin__field">
            <span class="image-cache-admin__label">Toy line</span>
            <input type="text" class="image-cache-admin__input" value.bind="imageCacheAdmin.formToyLine" disabled.bind="imageCacheAdmin.saving" />
          </label>
        </div>
        <div class="image-cache-admin__form-actions">
          <button type="button" class="login-btn login-btn--secondary" click.trigger="imageCacheAdmin.resetForm()" disabled.bind="imageCacheAdmin.saving">Clear</button>
          <button type="submit" class="login-btn login-btn--primary" disabled.bind="imageCacheAdmin.saving">
            ${imageCacheAdmin.saving ? 'Saving&hellip;' : 'Save record'}
          </button>
        </div>
      </form>

      <div class="image-cache-admin__search">
        <input type="search" class="image-cache-admin__input" value.bind="imageCacheAdmin.search" keydown.trigger="$event.key === 'Enter' ? imageCacheAdmin.load() : true" placeholder="Search URL, brand, or toy line&hellip;" disabled.bind="imageCacheAdmin.loading" />
        <button type="button" class="login-btn login-btn--secondary" click.trigger="imageCacheAdmin.load()" disabled.bind="imageCacheAdmin.loading">Search</button>
      </div>

      <div if.bind="imageCacheAdmin.error" class="image-cache-admin__error">${imageCacheAdmin.error}</div>
      <div if.bind="imageCacheAdmin.loading" class="image-cache-admin__status">Loading image cache&hellip;</div>

      <div if.bind="!imageCacheAdmin.loading && imageCacheAdmin.entries.length === 0" class="image-cache-admin__status">
        No cache records match.
      </div>

      <ul if.bind="!imageCacheAdmin.loading && imageCacheAdmin.entries.length > 0" class="image-cache-admin__list">
        <li repeat.for="entry of imageCacheAdmin.entries" class="image-cache-admin__row">
          <div class="image-cache-admin__row-main">
            <a class="image-cache-admin__url" href.bind="entry.imageUrl" target="_blank" rel="noopener" title.bind="entry.imageUrl">${entry.imageUrl}</a>
            <div class="image-cache-admin__meta">
              <span class="image-cache-admin__tag ${entry.brand ? '' : 'image-cache-admin__tag--empty'}">${entry.brand || 'unidentified'}</span>
              <span if.bind="entry.toyLine" class="image-cache-admin__tag image-cache-admin__tag--line">${entry.toyLine}</span>
            </div>
          </div>
          <div class="image-cache-admin__row-actions">
            <button type="button" class="image-cache-admin__action" click.trigger="imageCacheAdmin.editEntry(entry)" disabled.bind="entry.deleting" aria-label="Edit record">Edit</button>
            <button type="button" class="image-cache-admin__action image-cache-admin__action--danger" click.trigger="imageCacheAdmin.deleteEntry(entry)" disabled.bind="entry.deleting" aria-label="Delete record">Delete</button>
          </div>
        </li>
      </ul>
    </div>

    <div class="image-cache-admin__footer">
      <div class="image-cache-admin__footer-left">
        <button type="button" class="login-btn login-btn--secondary" click.trigger="imageCacheAdmin.reprocessUnknowns()" disabled.bind="imageCacheAdmin.reprocessing" title="Reapply the image cache to releases still tagged Unknown (no re-scrape)">
          ${imageCacheAdmin.reprocessing ? 'Reprocessing&hellip;' : 'Reprocess unknowns'}
        </button>
        <span if.bind="imageCacheAdmin.reprocessMessage" class="image-cache-admin__reprocess-result">${imageCacheAdmin.reprocessMessage}</span>
      </div>
      <button type="button" class="login-btn login-btn--primary" click.trigger="imageCacheAdmin.closePanel()">Close</button>
    </div>
  </div>
</div>
